// Globals
import { useTranslation } from 'react-i18next';

// Modules
import { Header } from '@/modules/Layout';
import { LLMTemplatesTable } from '../../components';

// Helpers
import { useGetLLMTemplates } from '../../hooks';
import { StyledContainer } from './LLMTemplatesContainerStyles';

const LLMTemplatesContainer = () => {
  const { t } = useTranslation();
  const { isLoading, templates } = useGetLLMTemplates();

  return (
    <>
      <Header title={t('menu_llm_templates')} />
      <StyledContainer>
        <LLMTemplatesTable templates={templates} isLoading={isLoading} />
      </StyledContainer>
    </>
  );
};

export default LLMTemplatesContainer;
